export const agentConstants = {
  AGENT_DETAILS: "AGENT_DETAILS",
  GET_AGENT_LISTING: "GET_AGENT_LISTING",
  PROPERTY_PAGINATION: "PROPERTY_PAGINATION",
};

export const createListingFormTypes = {
  TYPE_DETAILS: "details",
  TYPE_FEATURES: "features",
};

export const electricityBackupOptions = {
  1: "None",
  2: "Generator",
  3: "UPS",
  4: "Solar",
};

export const flooringTypeOptions = {
  1: "Wooden",
  2: "Tiles",
  3: "Marble",
  4: "Chip",
  5: "Cement",
};

export const propertViewOptions = {
  1: "Furnished",
  2: "Semi-Furnished",
  3: "Unfurnished",
};

export const allowedFileTypesForRegistrationCertificate =
  ".jpg, .jpeg, .png, .pdf, .doc, .docx";

export const PAYMENT_DISABLED = "Payment Disabled";

export const PAYMENT_DISABLED_MESSAGE =
  "The agent has an active subscription. Are you sure you want to disable payments?";

